import { ShareResourceEnum } from 'modules/share/enum/share-resource-enum'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { getResourceApiSlug } from './get-resource-api-slug'

export const getSuccessMessage = (t: TLocoType, type?: ShareResourceEnum) => {
  const resourceApiSlug = getResourceApiSlug(type)
  switch (resourceApiSlug) {
    case ShareResourceEnum.Funnel:
      return t('dashboard.share.funnel.success')
    case ShareResourceEnum.Blog:
      return t('dashboard.share.blog.success')
    case ShareResourceEnum.Newsletter:
      return t('dashboard.share.newsletter.success')
    case ShareResourceEnum.Campaign:
      return t('dashboard.share.campaign.success')
    case ShareResourceEnum.Course:
      return t('dashboard.share.course.success')
    case ShareResourceEnum.MasterBlock:
      return t('dashboard.share.master_block.success')
    case ShareResourceEnum.UserBlock:
      return t('dashboard.share.user_block.success')
    case ShareResourceEnum.Workflow:
      return t('dashboard.share.workflow.success')
    case ShareResourceEnum.Website:
      return t('dashboard.share.website.success')
    default:
      return ''
  }
}
